import { SHARE_DESTINATIONS } from '../constants/analytics';
import { OidcUser } from '../types/oidcUser';
import { analytics } from './analytics';
import { ContentType } from './contentType';

/**
 * Extract ID from URL (last segment)
 */
export const extractIdFromUrl = (url: string): string => {
  const base = url.split('#')[0].split('?')[0];
  const parts = base.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
};

/**
 * Get current user's full name from OIDC user object
 */
export const getCurrentUserFullName = (user: OidcUser | null): string => {
  const profile = user?.profile;
  const fullName = [profile?.firstName, profile?.lastName]
    .filter(Boolean)
    .join(' ');
  return fullName || profile?.name || 'Unknown';
};

/**
 * Track content sharing event (for catalog content)
 */
export const trackContentShared = (params: {
  contentId: string;
  contentType: ContentType;
  contentName: string;
  creatorName: string;
  shareDestination: string;
}) => {
  analytics.logEvent('content_shared', {
    content_id: params.contentId,
    content_type: params.contentType,
    content_name: params.contentName,
    creator_name: params.creatorName,
    share_destination: params.shareDestination,
  });
};

/**
 * Track creation sharing event (for user-created content)
 */
export const trackCreationShare = (params: {
  contentId: string;
  contentType: 'Music';
  contentName: string;
  creatorName: string;
  shareDestination: string;
}) => {
  analytics.logEvent('creation_share', {
    content_id: params.contentId,
    content_type: params.contentType,
    content_name: params.contentName,
    creator_name: params.creatorName,
    share_destination: params.shareDestination,
  });
};

/**
 * Track creation download event
 */
export const trackCreationDownloaded = (params: {
  creationId: string;
  creationType: ContentType;
  creationName: string;
  creationCompanion: string;
}) => {
  analytics.logEvent('creation_downloaded', {
    creation_id: params.creationId,
    creation_type: params.creationType,
    creation_name: params.creationName,
    creation_companion: params.creationCompanion,
  });
};

/**
 * Get share destination name from platform key
 */
export const getShareDestination = (platform: string): string => {
  const destinationMap: Record<string, string> = {
    facebook: SHARE_DESTINATIONS.FACEBOOK,
    twitter: SHARE_DESTINATIONS.TWITTER,
    whatsapp: SHARE_DESTINATIONS.WHATSAPP,
    telegram: SHARE_DESTINATIONS.TELEGRAM,
    linkedin: SHARE_DESTINATIONS.LINKEDIN,
  };
  return destinationMap[platform] || platform;
};
